module.exports = __webpack_public_path__ + "static/img/Aaclogo2.7ea5da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogo2.png
// module id = hz6C
// module chunks = 1